function EventsCard() {
    "use strict";
    this.EventId = -1;
    this.MetaEventId = -1;
    this.MetaEventDescription = '';
    this.EnrolleeId = -1;
    this.EnrolleeName = '- unknown -';
    this.EnrolleeFirstName = '';
    this.EnrolleeLastName = '';
    this.StartDateUTC = new Date();
    this.StartDateDisplay = '';
    this.StopDateUTC = new Date();
    this.StopDateDisplay = '';
    this.Duration = 0;
    this.DeviceId = -1;
    this.ZoneName = '- none - ';
    this.ZoneTrackPointCount = 0;
    this.SerialNumber = '';
    this.IsOpen = false;
    this.HasNotes = false;
    this.HasNotesDisplay = '';
    this.ConfirmedDateUTC = localizeText('cEventNotConfirmed');
    this.IsConfirmed = false;
    this.IsConfirmedDisplay = '';
    this.ConfirmedByUserID = -1;
    this.ConfirmedByName = localizeText('cEventNotConfirmed');
    this.IsMyCaseload = false;
    this.SortOrder = 3;
    this.IsAssigned = false;
    this.DataItem = null;
    this.ItemId = null;
    this.SortId = '';
    this.HasMonitoredEvent = false;
    this.RiskLevel = '';
    this.RiskLevelId = -1;
    this.OrganizationId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = EventsCard;
}